document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll(
            "#shopify-section-sections--22287418163385__page_header_image_banner_jh3iBw .hero__text, #shopify-section-sections--22287418163385__page_header_image_banner_jh3iBw .hero__button--gap, #shopify-section-sections--22287418163385__page_header_image_banner_jh3iBw div[data-block-id='subheading_KF89aH']"
        ).forEach(element => {
            element.classList.remove("scroll-trigger", "animate--slide-in");
        });
});

document.addEventListener("DOMContentLoaded", () => {
    const counter = document.getElementById("heading_zYRPUX-evm");

    const start = 90;
    const end = 98;
    const duration = 800; // 1.5 seconds

    let startTime = null;

    function updateCounter(timestamp) {
        if (!startTime) startTime = timestamp;

        const progress = Math.min((timestamp - startTime) / duration, 1);

        const current = Math.floor(progress * (end - start) + start);

        counter.textContent = `${current}%`;

        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            counter.textContent = `${end}%`;
        }
    }

    requestAnimationFrame(updateCounter);
});

document.addEventListener("DOMContentLoaded", () => {
    const counter = document.getElementById("heading_zYRPUX-evm");

    const start = 90;
    const end = 98;
    const duration = 800;

    let hasAnimated = false;

    function animateCounter() {
        let startTime = null;

        function update(timestamp) {
            if (!startTime) startTime = timestamp;

            const progress = Math.min((timestamp - startTime) / duration, 1);

            const current = Math.floor(progress * (end - start) + start);

            counter.textContent = `${current}%`;

            if (progress < 1) {
                requestAnimationFrame(update);
            } else {
                counter.textContent = `${end}%`;
            }
        }

        requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !hasAnimated) {
                hasAnimated = true;
                animateCounter();
            }
        });
    }, {
        threshold: 0.5
    });

    observer.observe(counter);
});

document.addEventListener("DOMContentLoaded", () => {

    const footer = document.querySelector("footer.wt-footer ");
    const video = document.querySelector("#shopify-section-sections--22287418065081__background_video_UfrBxU");

    if (!footer || !video) return;

    function updateVideoState() {
        const footerRect = footer.getBoundingClientRect();

        // Footer has completely passed the viewport
        if (footerRect.bottom <= window.innerHeight) {
            video.classList.add("video-sticky");
        } else {
            video.classList.remove("video-sticky");
        }
    }

    window.addEventListener("scroll", updateVideoState);
    window.addEventListener("resize", updateVideoState);

    updateVideoState();
});

document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll(
        '#heading_CxK9Kr-evm, #shopify-section-template--22287424225465__features_banner_Lb3pEV .headline--rich.scroll-trigger'
    );

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.2
    });

    elements.forEach((element) => {
        observer.observe(element);
    });
});

document.addEventListener("DOMContentLoaded", function () {

    const elements = document.querySelectorAll(
        'h2#heading_CxK9Kr-evm, #shopify-section-template--22287424225465__features_banner_Lb3pEV .headline--rich.scroll-trigger h2, #heading_WHczA4-evm'
    );

    if (!elements.length) return;

    elements.forEach(function (element) {

        const originalText = element.textContent.trim();

        if (!originalText) return;

        element.innerHTML = "";

        element.classList.add("typewriter");

        const textNode = document.createTextNode("");
        const cursor = document.createElement("span");

        cursor.className = "typewriter-cursor";

        element.appendChild(textNode);
        // element.appendChild(cursor);

        let index = 0;
        let started = false;

        function typeText() {

            if (index < originalText.length) {

                textNode.textContent += originalText.charAt(index);

                index++;

                setTimeout(typeText, 40);

            } else {

                setTimeout(function () {
                    cursor.remove();
                }, 1000);

            }
        }

        const observer = new IntersectionObserver(function (entries) {

            entries.forEach(function (entry) {

                if (entry.isIntersecting && !started) {

                    started = true;

                    typeText();

                    observer.unobserve(element);
                }

            });

        }, {
            threshold: 0.2
        });

        observer.observe(element);

    });

});

document.querySelectorAll(
  '#shopify-section-template--22287424225465__benefits_product_DGyBfk .headline a'
).forEach(link => {
  link.classList.add('hero__button--primary', 'hero__button');
});

// document.addEventListener("DOMContentLoaded", function () {
//   if (window.innerWidth <= 749) {
//     const links = document.querySelectorAll('.card.card--left');

//     links.forEach(function (link) {
//       link.removeAttribute("href");
//       link.style.cursor = "default";
//     });
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {

//   if (window.innerWidth <= 749) {

//     const cards = document.querySelectorAll('.card.card--left');

//     cards.forEach(function (card) {
      
//       card.removeAttribute("href");

//       let imageTimer;
      
//       card.addEventListener("click", function (event) {

//         event.preventDefault();

//         clearTimeout(imageTimer);

//         card.classList.add("mobile-image-active");

//         imageTimer = setTimeout(function () {
//           card.classList.remove("mobile-image-active");
//         }, 2000);

//       });

//     });

//   }

// });